const posturasMutations = {
	SET_YEAR_MAIN: 'SET_YEAR_MAIN',
	SET_SEASON_MAIN: 'SET_SEASON_MAIN'
};

export default Object.freeze({
	...posturasMutations,
});
